function getWrapperElement () {
  var wrapperEl = document.getElementById('cinnamon-toasts')
  let body = document.body
  if (!wrapperEl) {
    wrapperEl = document.createElement('div')
    wrapperEl.id = 'cinnamon-toasts'
    body.insertAdjacentElement('afterbegin', wrapperEl)
  }
  return wrapperEl
}

function createToastElement (toast, parentElement) {
  let closeButton = null
  let toastEl = document.createElement('div')
  toastEl.classList.add('cinnamon-toast')
  let message = document.createTextNode(toast.message)
  toastEl.appendChild(message)
  if (toast.error) {
    toastEl.classList.add('toast-error')
  }
  if (toast.dismissible) {
    closeButton = document.createElement('button')
    closeButton.appendChild(document.createTextNode('Dismiss'))
    toastEl.appendChild(closeButton)
  }
  parentElement.insertAdjacentElement('afterBegin', toastEl)
  return toastEl
}

function dismiss (toastEl, wrapperEl, immediate) {
  let ms = 3000
  if (immediate) {
    ms = 0
  }
  // hide element first to give time for css transitions
  setTimeout(function () {
    toastEl.classList.add('hide-toast')
  }, ms)
  // remove element to keep the dom clean
  setTimeout(function () {
    wrapperEl.removeChild(toastEl)
  }, ms + 800)
}

function trigger (toast) {
  let wrapperEl = getWrapperElement()
  let toastEl = createToastElement(toast, wrapperEl)
  if (!toast.dismissible) {
    dismiss(toastEl, wrapperEl)
  } else {
    toastEl.lastElementChild.addEventListener('click', function () {
      dismiss(toastEl, wrapperEl, true)
    })
  }
}

module.exports = function (message, options) {
  let defaults = {
    error: false,
    dismissible: false
  }
  // Merge with options: Overriding defaults if any
  defaults = Object.assign({}, defaults, options)

  let toast = {
    message: message,
    error: defaults.error,
    dismissible: defaults.dismissible
  }

  trigger(toast)
}
